import clinicAddress from "./clinicAddress";
import currency from "@/filters/currency";

export default {
  install(Vue) {
    Vue.filter("clinicAddress", clinicAddress);
    Vue.filter("currency", currency);
  }
};
